import Page from './PrizePage'
export default Page;